<template>
  <fin-header-footer-container content-color="#edf1f4" footer-color="#edf1f4" header-color="#edf1f4"
                               page-color="#edf1f4" vertical-centered>
    <template #default="{ footerHeight }">
      <v-row align="center" class="mx-0" justify="center">
        <v-col cols="12" style="max-width: 600px">
          <h1 style="text-align: center; font-size: 32px;" v-html="header"/>

          <v-row v-if="!token" align="end">
            <v-col cols="12">
              <p class="mb-0">Schade, dass du unsere Updates nicht mehr erhalten möchtest.<br/><br/>Hierzu musst
                du deine E-Mail Adresse angeben, so dass wir dir eine Mail mit dem Unsubscribe Link zuschicken können.
              </p>
            </v-col>
            <v-col cols="10">
              <fin-email-input v-model="email"
                               hide-details/>
            </v-col>
            <v-col cols="2">
              <v-btn icon
                     title="Absenden"
                     @click="submitNewsletterUnsubscribe">
                <v-icon>icon-save</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <fin-error-msg v-if="resendError"
                             :msg="resendText"
                             style="background-color: #edf1f4 !important;"/>
              <fin-info-msg v-else
                            :msg="resendText"/>

              <p v-if="resendError" style="font-size: 14px; text-align: center;">
                Falls weiterhin Probleme auftreten, kontaktiere uns:
                <br/>
                <a href="mailto:support@fincraft.de">support@fincraft.de</a>
              </p>
            </v-col>
          </v-row>

          <v-row v-if="token">
            <v-col>
              <v-img :height="125"
                     :src="require('@/assets/onboarding/registration/'+ img.src + '.svg')"
                     :width="img.width"
                     class="my-5"
                     contain
                     style="margin: 0 auto; transform: rotate(90deg);"/>
            </v-col>
            <v-col align-self="center">
              <template v-if="error">
                <fin-error-msg
                  msg="Fehler beim Abmelden vom unseren Updates! Versuche es erneut oder kontaktiere uns (s.u.)."
                  style="background-color: #edf1f4 !important;"/>
                <p style="font-size: 14px; text-align: center;">
                  Falls weiterhin Probleme auftreten, kontaktiere uns:
                  <br/>
                  <a href="mailto:support@fincraft.de">support@fincraft.de</a>
                </p>
              </template>

              <template v-else>
                <fin-info-msg :msg="text"/>
              </template>
            </v-col>
          </v-row>

          <v-row>
            <v-col align="center">
              <v-btn text to="/">Zurück zur Startseite</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </template>
  </fin-header-footer-container>
</template>

<script>
import {Analytics, API} from "@/plugins/finAmplifyModules"
import {unregisterNewsletterUser, unregisterNewsletterUserRequest} from "@/js/finMutations"
import FinHeaderFooterContainer from "@/components/common/HeaderFooterContainer"
import FinEmailInput from "@/components/common/form/EmailInput"
import FinErrorMsg from "@/components/common/ErrorMsg"
import FinInfoMsg from "@/components/common/InfoMsg"
import { mapGetters } from "vuex"

export default {
  name: "finNewsletterUnsubscribe",
  components: {FinInfoMsg, FinErrorMsg, FinEmailInput, FinHeaderFooterContainer},
  data() {
    return {
      header: 'Abmeldung von unseren Updates',
      text: null,
      img: {
        src: 'email-confirmation',
        width: '110'
      },
      token: null,
      email: null,
      error: false,
      resendText: null,
      resendError: false,
    }
  },
  computed: {
    ...mapGetters('auth', ['publicQueryAuthMode']),
  },
  methods: {
    async unsubscribe() {
      try {
        let unsubscribeResult = await API.graphql({
          query: unregisterNewsletterUser,
          variables: {token: this.token},
          authMode: this.publicQueryAuthMode
        })

        if (unsubscribeResult.data.unregisterNewsletterUser === 'OK') {
          this.text = 'Ab sofort erhältst du keine Updates mehr.'
        } else if (unsubscribeResult.data.unregisterNewsletterUser === 'UNREGISTERED') {
          this.text = 'Zu deiner E-Mail-Adresse liegt keine Registrierung vor. Evtl. hattest du dich schon abgemeldet.'
        } else {
          console.log("ERROR unsubscribing newsletter user", unsubscribeResult.data)
          this.error = true
        }
      } catch (error) {
        console.log("ERROR unsubscribing newsletter user", error, this.token)
        this.error = true
      }
    },
    async submitNewsletterUnsubscribe() {
      try {
        let unsubscribeResult = await API.graphql({
          query: unregisterNewsletterUserRequest,
          variables: {baseURL: window.location.origin, email: this.email.trim()},
          authMode: this.publicQueryAuthMode
        })

        if (unsubscribeResult.data.unregisterNewsletterUserRequest === 'OK') {
          this.resendText = 'Es wurde dir ein Abmeldelink für unsere Updates an deine angegebene E-Mail-Adresse geschickt.'
        } else if (unsubscribeResult.data.unregisterNewsletterUserRequest === 'UNREGISTERED') {
          this.resendText = 'Zu deiner E-Mail-Adresse liegt keine Registrierung vor. Evtl. hattest du dich schon abgemeldet.'
        } else {
          console.log("ERROR sending unsubscribe mail", unsubscribeResult.data)
          this.resendError = true
          this.resendText = 'Es trat ein Fehler auf. Versuche es erneut oder kontaktiere uns (s.u.).'
        }
      } catch (error) {
        console.log("ERROR sending unsubscribe mail", error, this.email)
        this.error = true
      }
    }
  },
  mounted() {
    Analytics.record({ name: 'newsletterUnsubscribeVisit' })
    this.token = this.$route.query.token

    if (this.token) {
      this.unsubscribe()
    }
  }
}
</script>

<style scoped>

</style>
